export const isXnft = process.env.XNFT === "true";

export const isWeb = process.env.WEB === "true";

export const isMobile = process.env.MOBILE === "true";
